"use client";

import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import ReportsCalendar from "../../../components/ReportsCalendar";

export default function CashUpPage() {
  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      date: "Friday, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 2,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 3,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 4,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 5,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 6,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 7,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 8,
      date: "Thu, 7 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 9,
      date: "Wed, 6 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 10,
      date: "Tues, 5 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 11,
      date: "Mon, 4 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 12,
      date: "Sun, 3 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 13,
      date: "Sat, 1 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
    {
      id: 14,
      date: "Tues, 5 Aug 2025",
      by: "Dave Smith",
      notes: "Note goes here....",
    },
  ];

  return (
    <div className="p-4 lg:p-6 w-full">
      {/* Header */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm mb-6">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between p-4 lg:px-6 lg:py-4 gap-4">
          <h1 className="text-xl lg:text-2xl font-bold text-[#885ABB]">Cash Up</h1>

          <div className="flex flex-wrap items-center gap-2 lg:gap-3">
            <button
              disabled
              className="flex-1 lg:flex-none px-4 py-2.5 lg:px-6 lg:py-3 border border-gray-200 rounded-xl text-xs lg:text-sm font-bold text-gray-400 bg-gray-50 cursor-not-allowed"
            >
              Print
            </button>

            <button
              disabled
              className="flex-1 lg:flex-none px-4 py-2.5 lg:px-6 lg:py-3 border border-gray-200 rounded-xl text-xs lg:text-sm font-bold text-gray-400 bg-gray-50 cursor-not-allowed"
            >
              Transaction
            </button>

            <button className="w-full lg:w-auto px-4 py-2.5 lg:px-6 lg:py-3 border border-purple-200 rounded-xl text-xs lg:text-sm font-bold text-[#402B69] hover:bg-purple-50 transition-colors">
              Open Cash Drawer
            </button>

            {/* New ReportsCalendar (handles its own popover) */}
            <div className="w-full lg:w-auto">
              <ReportsCalendar />
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-transparent lg:bg-white lg:border lg:border-gray-200 lg:rounded-xl overflow-hidden shadow-sm lg:shadow-none">
        {/* Desktop Header */}
        <div className="hidden lg:grid grid-cols-[300px_200px_1fr] bg-[#885ABB] text-white font-bold text-sm">
          <div className="px-6 py-4 ml-8">Date</div>
          <div className="px-6 py-4">Completed By</div>
          <div className="px-6 py-4">Notes</div>
        </div>

        {/* Rows */}
        <div className="flex flex-col gap-3 lg:gap-0">
          {rows.map((row) => (
            <div
              key={row.id}
              // onClick={() => navigate(`/cashup/${row.id}`)}
              className="flex flex-col lg:grid lg:grid-cols-[300px_200px_1fr] bg-white border lg:border-0 lg:border-t border-gray-200 rounded-xl lg:rounded-none p-4 lg:p-0 text-sm text-gray-500 hover:text-black hover:bg-purple-50/30 transition-all cursor-pointer relative group"
            >
              <div className="flex items-center gap-3 lg:px-6 lg:py-4">
                <input
                  type="checkbox"
                  className="h-5 w-5 lg:h-6 lg:w-6 appearance-none border-2 border-purple-200 rounded-md cursor-pointer
                    checked:bg-[#885ABB] checked:border-[#885ABB]
                    relative checked:after:content-[''] checked:after:absolute
                    checked:after:left-1/2 checked:after:top-1/2
                    checked:after:-translate-x-1/2 checked:after:-translate-y-1/2
                    checked:after:w-[5px] lg:checked:after:w-[6px] checked:after:h-[10px] lg:checked:after:h-[12px]
                    checked:after:border-r-2 checked:after:border-b-2 checked:after:border-white
                    checked:after:rotate-45 transition-all"
                  onClick={(e) => e.stopPropagation()}
                />
                <div>
                  <span className="lg:hidden text-[10px] uppercase tracking-wider text-gray-400 font-bold block mb-0.5">Date</span>
                  <span className="font-bold lg:font-medium text-gray-900 lg:text-inherit">{row.date}</span>
                </div>
              </div>
              <div className="mt-3 lg:mt-0 lg:px-6 lg:py-4 border-t lg:border-0 border-gray-50 pt-3 lg:pt-4">
                <span className="lg:hidden text-[10px] uppercase tracking-wider text-gray-400 font-bold block mb-0.5">Completed By</span>
                <span className="font-medium lg:font-normal">{row.by}</span>
              </div>
              <div className="mt-2 lg:mt-0 lg:px-6 lg:py-4 text-xs lg:text-sm">
                <span className="lg:hidden text-[10px] uppercase tracking-wider text-gray-400 font-bold block mb-0.5">Notes</span>
                <span className="line-clamp-2 lg:line-clamp-none">{row.notes}</span>
              </div>

              {/* Desktop Chevron */}
              <div className="hidden lg:flex absolute right-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity">
                <ChevronRight className="w-5 h-5 text-[#885ABB]" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
